import React from "react";

import SiteFooterContent from "./SiteFooterContent";

export default function MainFooter() {
    return <SiteFooterContent/>;
}
